const NGTConfigKey = {};

NGTConfigKey.SKIPPABLE_CONTENT = "ngt.skippableContent";
NGTConfigKey.USE_AUTO_VOICEOVER = "ngt.useAutoVoiceOver";
NGTConfigKey.SCENARIOS = "ngt.scenarios";


export default NGTConfigKey;